const SiteLayout = () =>
  import(
    /* webpackChunkName: "site-layout" */ '@/pages/site-generator/cms/layout/index.vue'
  )
const CreateSiteLayout = () =>
  import(
    /* webpackChunkName: "site-layout" */ '@/pages/site-generator/cms/layout/create.vue'
  )
const EditSiteLayout = () =>
  import(
    /* webpackChunkName: "site-layout" */ '@/pages/site-generator/cms/layout/edit.vue'
  )

export default {
  path: 'layout',
  meta: {
    label: 'layout',
    auth: 'layout'
  },
  component: {
    name: 'Layout',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteLayoutReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SiteLayout
    },
    {
      name: 'SiteCreateLayout',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSiteLayout
    },
    {
      name: 'SiteEditLayout',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSiteLayout,
      props: true
    }
  ]
}
